<!-- Responsibility: Render the full atlas dialog content surface.
Scope: Atlas dialog content only; modal lifecycle is owned by game-modal/app-shell. -->
<atlas-dialog class="atlas-sheet">
  <header>
    <div>
      <p>Atlas</p>
      <h3>{ roomName() }</h3>
    </div>
    <span>{ nodeCountLabel() }</span>
  </header>

  <atlas-map if={ mapView() } view={ mapView() }></atlas-map>

  <section if={ routes().length }>
    <header>
      <strong>Known passages</strong>
      <span>{ routes().length } nearby</span>
    </header>
    <ul>
      <li each={ route in routes() }>
        <button type="button" onclick={ () => props.content?.onOpenRoute?.(route) }>
          <strong>{ route.title }</strong>
          <span>{ route.meta }</span>
        </button>
      </li>
    </ul>
  </section>

  <section if={ presences().length }>
    <header>
      <strong>Known presences elsewhere</strong>
      <span>{ presences().length } nodes</span>
    </header>
    <ul class="offsite">
      <li each={ entry in presences() }>
        <strong>{ entry.shortName }</strong>
        <span>{ entry.summary }</span>
      </li>
    </ul>
  </section>

  <script>
    import AtlasMap from '../atlas-map.riot'

    export default {
      components: { AtlasMap },

      atlas() {
        return this.props.content?.atlas ?? null
      },

      location() {
        return this.props.content?.location ?? null
      },

      currentRoom() {
        return this.props.content?.currentRoom ?? null
      },

      currentVisionUrl() {
        return String(this.props.content?.currentVisionUrl ?? '').trim()
      },

      mapView() {
        const atlas = this.atlas()
        const location = this.location()
        if (!atlas || !location) return null
        return {
          atlas,
          location,
          currentRoom: this.currentRoom(),
          currentVisionUrl: this.currentVisionUrl(),
          expanded: true,
        }
      },

      roomName() {
        return String(this.props.content?.roomName ?? 'Unknown room').trim() || 'Unknown room'
      },

      routes() {
        return Array.isArray(this.props.content?.routeSummaries) ? this.props.content.routeSummaries : []
      },

      presences() {
        return Array.isArray(this.props.content?.worldNpcNodes) ? this.props.content.worldNpcNodes : []
      },

      nodeCountLabel() {
        const atlas = this.atlas()
        const count = Object.keys(atlas?.nodes ?? {}).length
        return `${count} nodes`
      },
    }
  </script>

  <style>
    atlas-dialog {
      display: grid;
      gap: var(--space-md);
    }

    atlas-dialog > header,
    atlas-dialog > section > header {
      display: flex;
      align-items: end;
      justify-content: space-between;
      gap: var(--space-sm);
      flex-wrap: wrap;
    }

    atlas-dialog > header > div,
    atlas-dialog > section > header {
      min-width: 0;
    }

    atlas-dialog p,
    atlas-dialog h3,
    atlas-dialog strong,
    atlas-dialog span {
      margin: 0;
    }

    atlas-dialog > header p,
    atlas-dialog > section > header > strong {
      color: color-mix(in srgb, var(--gold) var(--alpha-high), var(--text-prose));
      font-size: var(--space-sm);
      letter-spacing: 0.12em;
    }

    atlas-dialog > header h3 {
      color: var(--text-prose, var(--text-prose));
      font-size: 1.08rem;
      line-height: 1.15;
    }

    atlas-dialog > header > span,
    atlas-dialog > section > header > span {
      color: var(--text-dim, #93a8c2);
      font-size: var(--space-sm);
      line-height: 1.35;
    }

    atlas-dialog > section {
      display: grid;
      gap: 0.65rem;
      padding: 0.85rem 0.92rem;
      border: 1px solid color-mix(in srgb, var(--border) var(--alpha-ghost), transparent);
      border-radius: var(--space-md);
      background: linear-gradient(180deg, color-mix(in srgb, var(--surface-card-2) var(--alpha-high), #06101b), color-mix(in srgb, var(--surface-card-1) var(--alpha-high), var(--bg)));
    }

    atlas-dialog ul {
      list-style: none;
      margin: 0;
      padding: 0;
      display: grid;
      gap: var(--space-xs);
    }

    atlas-dialog li > button,
    atlas-dialog .offsite > li {
      width: 100%;
      display: grid;
      gap: 0.18rem;
      padding: 0.68rem var(--space-sm);
      border: 1px solid color-mix(in srgb, var(--border) var(--alpha-ghost), transparent);
      border-radius: 0.9rem;
      background: color-mix(in srgb, rgba(5, 10, 18, 0.82) var(--alpha-high), transparent);
      text-align: left;
    }

    atlas-dialog li > button {
      color: inherit;
      font: inherit;
      cursor: pointer;
      transition: transform 0.18s ease, border-color 0.18s ease;
    }

    atlas-dialog li > button:hover,
    atlas-dialog li > button:focus-visible {
      transform: translateY(-1px);
      border-color: color-mix(in srgb, var(--gold) var(--alpha-ghost), transparent);
      outline: none;
    }

    atlas-dialog li > button > strong,
    atlas-dialog .offsite > li > strong {
      color: var(--text-prose, var(--text-prose));
      font-size: 0.88rem;
      line-height: 1.3;
    }

    atlas-dialog li > button > span,
    atlas-dialog .offsite > li > span {
      color: var(--text-dim, #93a8c2);
      font-size: var(--space-sm);
      line-height: 1.45;
    }
  </style>
</atlas-dialog>
